<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form @keyup.enter.native="searchQuery" layout="inline">
        <a-row :gutter="24">
          <a-col :lg="7" :md="8" :sm="24" :xl="6">
            <a-form-item label="图形名称">
              <a-input placeholder="请输入图形名称" v-model="queryParam.topoName"></a-input>
            </a-form-item>
          </a-col>
          <a-col :lg="7" :md="8" :sm="24" :xl="6">
            <a-form-item label="供水流域">
              <j-dict-select-tag
                dictCode="`iwt-wf`.dev_process,process_name,id"
                placeholder="请选择供水流域"
                v-model="queryParam.processId"
              />
            </a-form-item>
          </a-col>
          <a-col :lg="7" :md="8" :sm="24" :xl="6">
            <span class="table-page-search-submitButtons" style="float: left;overflow: hidden;">
              <a-button @click="searchQuery" icon="search" type="primary">查询</a-button>
              <a-button @click="searchReset" icon="reload" style="margin-left: 8px" type="primary">重置</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->

    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <a-button @click="addTopo" icon="plus" type="primary">新增</a-button>
      <!-- 高级查询区域 -->
      <j-super-query :fieldList="superFieldList" @handleSuperQuery="handleSuperQuery" ref="superQueryModal"></j-super-query>
    </div>

    <!-- table区域-begin -->
    <div>
      <a-list
        :dataSource="dataSource"
        :grid="{ gutter: 24, lg: 4, md: 2, sm: 1, xs: 1 }"
        :loading="loading"
        :pagination="{ ...paginationProps }"
      >
        <a-list-item slot="renderItem" slot-scope="item, index">
          <a-card
            :headStyle="{ 'text-align': 'center' }"
            :hoverable="true"
            :title="item.topoName + (item.isMain == 1 ? '【主页】' : '')"
            size="small"
          >
            <!-- 刷新icon extra -->
            <a-icon @click="getTopoDetailByItem(item)" slot="extra" type="reload" />
            <img :src="item.snapshot" :style="{ height: '20vh' }" alt="缩略图" slot="cover" />
            <template class="ant-card-actions" slot="actions">
              <a>
                <a-button @click="previewTopo(item)" icon="eye" size="small" type="link">预览</a-button>
              </a>
              <a-button @click="handleEdit1(item)" icon="setting" size="small" type="link">配置</a-button>
              <a-button @click="editTopo(item)" icon="sliders" size="small" type="link">绘图</a-button>
              <a-dropdown>
                <a class="ant-dropdown-link">...</a>
                <a-menu slot="overlay">
                  <a-menu-item @click="handleCopy(item)">
                    <a-icon type="copy" />整站复制
                  </a-menu-item>
                  <a-menu-item>
                    <a-popconfirm @confirm="handleDelete(item.id)" title="确定删除吗?">
                      <a-icon type="delete" />删除
                    </a-popconfirm>
                  </a-menu-item>
                </a-menu>
              </a-dropdown>
              <!--   -->
            </template>
          </a-card>
        </a-list-item>
      </a-list>
    </div>

    <topo-graph-modal @ok="modalFormOk" ref="modalForm"></topo-graph-modal>
  </a-card>
</template>

<script>
  import '@/assets/less/TableExpand.less'
  import { mixinDevice } from '@/utils/mixin'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import TopoGraphModal from './modules/TopoGraphModal'
  import { filterMultiDictText } from '@/components/dict/JDictSelectUtil'
  import { getAction } from '../../api/manage'
  import { deleteTopoGraph } from '@/api/gis'

  export default {
    name: 'TopoGraphList',
    mixins: [JeecgListMixin, mixinDevice],
    components: {
      TopoGraphModal
    },
    data () {
      return {
        description: '组态图管理页面',
        // 表头
        columns: [
          {
            title: '#',
            dataIndex: '',
            key: 'rowIndex',
            width: 60,
            align: 'center',
            customRender: function (t, r, index) {
              return parseInt(index) + 1
            }
          },
          {
            title: '图形名称',
            align: 'center',
            dataIndex: 'topoName'
          },
          {
            title: '供水流域',
            align: 'center',
            dataIndex: 'processId_dictText'
          },
          {
            title: '快照',
            align: 'center',
            dataIndex: 'snapshot',
            scopedSlots: { customRender: 'imgSlot' }
          },
          {
            title: '更新日期',
            align: 'center',
            dataIndex: 'updateTime'
          },
          {
            title: '操作',
            dataIndex: 'action',
            align: 'center',
            fixed: 'right',
            width: 147,
            scopedSlots: { customRender: 'action' }
          }
        ],
        url: {
          list: '/topo/topoGraph/list',
          delete: '/topo/topoGraph/delete',
          deleteBatch: '/topo/topoGraph/deleteBatch',
          exportXlsUrl: '/topo/topoGraph/exportXls',
          importExcelUrl: '/topo/topoGraph/importExcel',
          queryById: '/topo/topoGraph/queryById'
        },
        dictOptions: {},
        superFieldList: [],
        ipagination: {
          current: 1,
          pageSize: 50,
          total: 0
        }
      }
    },
    created () {
      this.getSuperFieldList()
    },
    computed: {
      importExcelUrl: function () {
        return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`
      },
      paginationProps () {
        const _this = this
        return {
          ..._this.ipagination,
          onChange (page, pageSize) {
            _this.ipagination.pageSize = pageSize
            _this.ipagination.current = page
            _this.loadData()
          },
          onShowSizeChange (page, pageSize) {
            _this.ipagination.pageSize = pageSize
            _this.ipagination.current = page
            _this.loadData()
          }
        }
      }
    },
    methods: {
      addTopo () {
        sessionStorage.removeItem('layerid')
        sessionStorage.removeItem('layername')
        sessionStorage.removeItem('topologyData')
        this.$router.push({
          path: '/topology/edit'
        })
      },
      editTopo (item) {
        sessionStorage.removeItem('layerid')
        sessionStorage.removeItem('layername')
        sessionStorage.removeItem('topologyData')
        this.$router.push({ name: 'topology-edit', params: { id: item.id } })
      },
      previewTopo (item) {
        sessionStorage.removeItem('layerid')
        sessionStorage.removeItem('layername')
        sessionStorage.removeItem('topologyData')
        this.$router.push({ name: 'topology-preview', params: { id: item.id, processId: item.processId } })
      },
      handleEdit1: function (record) {
        this.$refs.modalForm.edit(record)
        this.$refs.modalForm.title = '修改图形名称'
        this.$refs.modalForm.disableSubmit = false
      },
      handleCopy: function (record) {
        this.$refs.modalForm.copy(record)
        this.$refs.modalForm.title = '新建图形名称'
        this.$refs.modalForm.disableSubmit = false
      },
      handleDelete: function (id) {
        deleteTopoGraph(id)
          .then(res => {
            this.$message.success('删除成功！')
            this.loadData()
          })
          .catch(err => {
            this.$message.error('删除失败！')
          })
      },
      loadData (arg) {
        console.log('---------')
        if (!this.url.list) {
          this.$message.error('请设置url.list属性!')
          return
        }
        // 加载数据 若传入参数1则加载第一页的内容
        if (arg === 1) {
          this.ipagination.current = 1
        }
        var params = this.getQueryParams() // 查询条件
        this.loading = true
        getAction(this.url.list, params)
          .then(res => {
            if (res.success) {
              this.dataSource = res.result.records || res.result
              if (res.result.total) {
                this.ipagination.total = res.result.total
              } else {
                this.ipagination.total = 0
              }
              this.getTopoDetail()
            } else {
              this.$message.warning(res.message)
            }
          })
          .finally(() => {
            this.loading = false
          })
      },
      getTopoDetailByItem (item, callback) {
        if (item.topoData) {
          callback && callback(item)
        }
        getAction(`/topo/topoGraph/queryById`, { id: item.id })
          .then(res => {
            if (res.success) {
              item.topoData = res.result.topoData
              item.snapshot = res.result.snapshot
              callback && callback(item)
            } else {
              this.$message.warning(res.message)
            }
          })
          .finally(() => {
            this.loading = false
          })
      },
      getTopoDetail () {
        for (let item of this.dataSource) {
          this.getTopoDetailByItem(item)
        }
      },
      initDictConfig () { },
      getSuperFieldList () {
        let fieldList = []
        fieldList.push({ type: 'string', value: 'topoName', text: '图形名称', dictCode: '' })
        fieldList.push({
          type: 'string',
          value: 'processId',
          text: '供水流域',
          dictCode: '`iwt-wf`.dev_process,process_name,id'
        })
        fieldList.push({ type: 'Text', value: 'snapshot', text: '快照', dictCode: '' })
        fieldList.push({ type: 'datetime', value: 'updateTime', text: '更新日期' })
        this.superFieldList = fieldList
      }
    }
  }
</script>
<style scoped>

  @import '~@assets/less/common.less';

</style>
